__turbopack_context__.v({
  "bullet-list": "ContentInterpreter-module-scss-module__21fbGW__bullet-list",
  "italic": "ContentInterpreter-module-scss-module__21fbGW__italic",
  "textWeightBold": "ContentInterpreter-module-scss-module__21fbGW__textWeightBold",
  "tooltip-content": "ContentInterpreter-module-scss-module__21fbGW__tooltip-content",
  "tooltip__span": "ContentInterpreter-module-scss-module__21fbGW__tooltip__span",
  "underline": "ContentInterpreter-module-scss-module__21fbGW__underline",
});
